import FrameBorder from "@/component/FrameBorder";
import Paginations from "@/component/Paginations";
import PATH from "@/config/PATH";
import { IS_UPDATE_VERSION_3_PROJECT } from '@/helper/const';
import { getDailyPrizeHistory } from '@/Redux/futures/daily-reward/actions';
import { getResultProduct } from "@/Redux/futures/result/action";
import backgroundImg from "@assets/web-v3-images/FrameBorder.png";
import { Text } from "@radix-ui/themes";
import dayjs from "dayjs";
import { formatHistoryDate } from '../formatDate';
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import SwiperCore, { Autoplay } from "swiper";
import "swiper/components/pagination/pagination.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import ButtonTab2 from "./ButtonTab2";
import ButtonTab3 from "./ButtonTab3";
import { NoDataContent } from "./NoData";

SwiperCore.use([Autoplay]);

const ImageSwiper = ({ product }) => {
  const images = product
    ? product?.split(",").map(item => item?.trim())
    : [];

  return (
    <Swiper
      pagination={{ clickable: true }}
      spaceBetween={12}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      slidesPerView={1}
      className="h-full"
      clickable={(e) => e.stopPropagation()}
    >
      {images.map((image, index) => (
        <SwiperSlide key={index}>
          <img
            src={image}
            alt={`product-${index}`}
            className="w-full h-full object-contain"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

const Texts = ({ text = "" }) => {
  return (
    <Text
      as="p"
      className="text-[rgba(154,90,59,1)] font-medium text-[25px] break-words"
    >
      {text}
    </Text>
  );
};

export default function Winners() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [active, setActive] = useState("weekly");
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [dataResApi, setdataResApi] = useState(null);
  const [activeT, setActiveT] = useState(0);

  const tabs = [
    {
      id: "weekly",
      label: t("history.weekly_reward"),
    },
    ...(IS_UPDATE_VERSION_3_PROJECT
      ? [
        {
          id: "daily",
          label: t("history.daily_reward"),
        },
      ]
      : []),
  ];

  const tabsT = [t("history.all_winners"), t("history.my_win")];

  const afterGetPackageHistory = (data, isLoading) => {
    if (data) {
      active === "weekly" ? setdataResApi(data) : setdataResApi(data?.data)
    }
  };

  const getCurrentPayload = (page) => {
    if (page === 1) {
      return 0;
    }
    return page;
  };

  const getPackageHistoryPage = () => {
    const body = {
      query:
        active === "weekly"
          ? {
            pageSize: 4,
            page: getCurrentPayload(page),
            scope: activeT === 0 ? "all" : "me",
          }
          : {
            page: page,
            limit: 4,
            scope: activeT === 0 ? "all" : "me",
          },
      callback: afterGetPackageHistory,
    };

    active === "weekly" ? dispatch(getResultProduct(body)) : dispatch(getDailyPrizeHistory(body));
  };

  const handleChangeActiveT = (value) => {
    if (value === activeT) return;
    setdataResApi();
    setPage(1);
    setActiveT(value);
  };

  const handleChangeActive = (value) => {
    if (value === active) return;
    setdataResApi(null);
    setPage(1);
    setActive(value);
  };

  useEffect(() => {
    getPackageHistoryPage();
  }, [page, activeT, active]);

  const handleClickButtonNodata = () => {
    active === "weekly" ? navigate(PATH.HOME) : navigate(PATH.DAILY_REWARD);
  };

  const totalPages = active === "weekly" ?
    Math.ceil(
      (dataResApi?.total || 0) / Number(dataResApi?.pageSize || 2),
    ) :
    Math.ceil(
      (dataResApi?.total || 0) / Number(dataResApi?.limit || 2),
    )

  return (
    <div className="min-h-0 flex flex-col">
      <ButtonTab2 data={tabs} active={active} setActive={handleChangeActive} />
      <FrameBorder fill>
        <div
          className="w-full bg-cover bg-no-repeat min-h-0 flex flex-col"
          style={{
            backgroundImage: `url(${backgroundImg})`,
          }}
        >
          <div className="mx-[8px] sm:mx-[30px] pt-5">
            <ButtonTab3 activeT={activeT} setActiveT={handleChangeActiveT} tabsT={tabsT} />
          </div>
          {dataResApi && dataResApi.total === 0 ? (
            <NoDataContent
              title={activeT === 0 ? t("history.no_winners_yet") : t("history.no_wins_yet")}
              textBtn={t('history.guess_price')}
              describe={activeT === 0 ? t("history.winners_will_be_announced_after_each_round") : t("history.keep_guessing_for_a_chance_to_win_prizes")}
              handleClick={handleClickButtonNodata}
            />
          ) : (
            <>
              <div className='overflow-y-auto min-h-0 scrollbar-thin scrollbar-thumb-[#E6B97D] scrollbar-track-transparent'>
                {
                  active === "weekly" ?
                    <>
                      {dataResApi?.data?.length > 0 &&
                        dataResApi?.data?.map((item, index) => {
                          return (
                            <div
                              className="p-[2%] pt-0 border-b border-b-[rgba(255,214,174,1)] mx-7"
                              key={index}
                            >

                              <div className="flex justify-between items-center gap-[5%]">
                                <div className="w-[30%] h-full">
                                  <ImageSwiper product={item?.product_image} />
                                </div>
                                <div className="w-[70%]">
                                  <Text
                                    as="p"
                                    className=" text-[rgba(84,35,20,1)] text-[28px] font-bold py-3"
                                  >
                                    {`${item?.product_name}`}
                                  </Text>
                                  <Texts
                                    text={`${t("product_prize")}: ${item?.product_price.toLocaleString("en-US")} MMK`}
                                  />
                                  <Texts text={`${t("event_new_year.code")}: ${item?.product_code}`} />
                                  <Texts
                                    text={`${t("start_date")}: ${formatHistoryDate(item?.start_time)}`}
                                  />
                                  <Texts
                                    text={`${t("end_date")}: ${formatHistoryDate(item?.end_time)}`}
                                  />
                                  <Texts text={`${t("result_page.winner")}: ${item?.isdn || ""}`} />
                                  <Texts
                                    text={`${t("guess_price")}: ${(item?.auction_price ?? 0).toLocaleString("en-US")} MMK`}
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </>
                    :
                    <>
                      {dataResApi?.items?.length > 0 &&
                        dataResApi?.items?.map((item, index) => {
                          return (
                            <div
                              className="p-[2%] pt-0 border-b border-b-[rgba(255,214,174,1)] mx-7"
                              key={index}
                            >
                              <div className="flex justify-between items-center gap-[5%]">
                                <div className="w-[30%] h-full">
                                  <ImageSwiper product={item?.illustrative_item?.image_url} />
                                </div>
                                <div className="w-[70%]">
                                  <Text
                                    as="p"
                                    className=" text-[rgba(84,35,20,1)] text-[28px] font-bold py-3"
                                  >
                                    {`${item?.illustrative_item?.name}`}
                                  </Text>
                                  <Texts text={`${t("event_new_year.code")}: ${item?.illustrative_item?.product_code}`} />
                                  <Texts
                                    text={`${t("start_date")}: ${formatHistoryDate(dayjs(item?.session_date).startOf("day"))}`}
                                  />
                                  <Texts
                                    text={`${t("end_date")}: ${formatHistoryDate(dayjs(item?.session_date).endOf("day"))}`}
                                  />
                                  <Texts text={`${t("result_page.winner")}: ${item?.winner_isdn_masked || ""}`} />
                                  <Texts
                                    text={`${t("guess_price")}: ${(item?.winner_guess_price ?? 0)?.toLocaleString("en-US")} MMK`}
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </>
                }
              </div>
              <Paginations
                current={page}
                totalPages={totalPages}
                onChange={(p) => setPage(p)}
              />
            </>
          )}
        </div>
      </FrameBorder>
    </div>
  );
}
